/**
 * Paylaşılan ekran durumu (mesajla "Paylaş"): alıcının ızgarası aynı süzgeç, arama, seçili
 * filtre ve sıralamayla açılır — çipler düzenlenebilir kalır (ham SQL taşınmaz).
 * Adreste `/s/<ScreenId>?f=<base64url JSON>` olarak durur. Veriyi alıcı KENDİ yetkisiyle görür.
 */
import type { SortingState } from '@tanstack/react-table';
import type { ColumnCriteria } from '../hooks/useGridCriteria';

export interface GridShareState {
  v: 1;
  criteria?: Record<string, ColumnCriteria>;
  search?: string;
  filterIds?: string[];
  sorting?: SortingState;
  grouping?: string[];
}

/** Adres sınırına yaklaşmamak için üst sınır (tarayıcılar ~32 bin karakteri sorunsuz taşır). */
export const MAX_SHARE_PARAM = 12_000;

const toB64Url = (s: string) => btoa(String.fromCharCode(...new TextEncoder().encode(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const fromB64Url = (s: string) => {
  const b = atob(s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4));
  return new TextDecoder().decode(Uint8Array.from(b, (c) => c.charCodeAt(0)));
};

export function encodeShareState(state: GridShareState): string {
  // Boş alanlar taşınmaz: bağlantı kısa kalsın.
  const compact: GridShareState = { v: 1 };
  if (state.criteria && Object.keys(state.criteria).length) compact.criteria = state.criteria;
  if (state.search?.trim()) compact.search = state.search.trim();
  if (state.filterIds?.length) compact.filterIds = state.filterIds;
  if (state.sorting?.length) compact.sorting = state.sorting;
  if (state.grouping?.length) compact.grouping = state.grouping;
  return toB64Url(JSON.stringify(compact));
}

export function decodeShareState(param: string | null | undefined): GridShareState | null {
  if (!param) return null;
  try {
    const raw = JSON.parse(fromB64Url(param)) as GridShareState;
    if (!raw || raw.v !== 1) return null;
    return {
      v: 1,
      criteria: raw.criteria && typeof raw.criteria === 'object' ? raw.criteria : undefined,
      search: typeof raw.search === 'string' ? raw.search.slice(0, 500) : undefined,
      filterIds: Array.isArray(raw.filterIds) ? raw.filterIds.filter((x) => typeof x === 'string') : undefined,
      sorting: Array.isArray(raw.sorting) ? raw.sorting : undefined,
      grouping: Array.isArray(raw.grouping) ? raw.grouping.filter((x) => typeof x === 'string') : undefined,
    };
  } catch {
    return null;
  }
}

export function shareUrl(screenId: string, state: GridShareState): string {
  const f = encodeShareState(state);
  return f === encodeShareState({ v: 1 }) ? `/s/${screenId}` : `/s/${screenId}?f=${f}`;
}
